import { render, staticRenderFns } from "./serveStation.vue?vue&type=template&id=6a2e3fd8&scoped=true&"
import script from "./serveStation.vue?vue&type=script&lang=js&"
export * from "./serveStation.vue?vue&type=script&lang=js&"
import style0 from "./serveStation.vue?vue&type=style&index=0&id=6a2e3fd8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e3fd8",
  null
  
)

export default component.exports